module.exports = __webpack_public_path__ + "static/img/20040B_1_C_20201226_fit.04e7e8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/20040B_1_C_20201226_fit.png
// module id = hF0t
// module chunks = 0